<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('storeOrderManage.queryConditions') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="conditions" class="flex flex-wrap justify-start align-center">
          <el-form-item style="margin-bottom: 10px;">
            <el-input v-model="conditions.orderId" :placeholder="$t('storeOrderManage.orderId')" clearable></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-select v-model="conditions.shopId" :placeholder="$t('storeOrderManage.selectShop')" clearable
              style="width: 180px">
              <el-option value="" :label="$t('storeOrderManage.selectShop')"></el-option>
              <el-option v-for="(item, index) in shops" :key="index" :label="item.shopName" :value="item.shopId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-select v-model="conditions.state" :placeholder="$t('storeOrderManage.selectStatus')" clearable
              style="width: 150px">
              <el-option value="" :label="$t('storeOrderManage.selectStatus')"></el-option>
              <el-option v-for="(item, index) in states" :key="index" :label="item.name" :value="item.statusCd">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-select v-model="conditions.cartType" :placeholder="$t('storeOrderManage.selectType')" clearable
              style="width: 150px">
              <el-option value="" :label="$t('storeOrderManage.selectType')"></el-option>
              <el-option v-for="(item, index) in cartTypes" :key="index" :label="item.name" :value="item.statusCd">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-input v-model="conditions.prodNameLike" :placeholder="$t('storeOrderManage.productName')" clearable>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-input v-model="conditions.personName" :placeholder="$t('storeOrderManage.userName')" clearable>
            </el-input>
          </el-form-item>
          <div style="width: 100%;"></div>
          <el-form-item style="margin-bottom: 10px;">
            <el-select v-model="conditions.personCommunityId" :placeholder="$t('storeOrderManage.selectPersonCommunity')" clearable
              style="width: 180px">
              <el-option value="" :label="$t('storeOrderManage.selectPersonCommunity')"></el-option>
              <el-option v-for="(item, index) in communities" :key="index" :label="item.name || item.communityName" :value="item.communityId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-date-picker
              v-model="conditions.startTime"
              type="datetime"
              :placeholder="$t('storeOrderManage.startTime')"
              value-format="yyyy-MM-dd HH:mm:ss"
              default-time="00:00:00">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-date-picker
              v-model="conditions.endTime"
              type="datetime"
              :placeholder="$t('storeOrderManage.endTime')"
              value-format="yyyy-MM-dd HH:mm:ss"
              default-time="23:59:59">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-button type="primary" size="small" @click="queryOrders()">
              <i class="el-icon-search"></i> {{ $t('storeOrderManage.query') }}
            </el-button>
            <el-button type="primary" size="small" @click="resetOrders()">
              <i class="el-icon-refresh"></i> {{ $t('storeOrderManage.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('storeOrderManage.orderInfo') }}</div>
        <div class="ibox-tools">
          <el-button type="primary" size="small" @click="exportOrders()">
            {{ $t('storeOrderManage.export') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="orders" style="width: 100%" border stripe>
          <el-table-column prop="orderId" :label="$t('storeOrderManage.orderId')" align="center"></el-table-column>
          <el-table-column :label="$t('storeOrderManage.productName')" align="center">
            <template slot-scope="scope">
              <div v-for="(cart, cIndex) in scope.row.storeOrderCartDtos" :key="cIndex">{{ cart.prodName }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('storeOrderManage.quantity')" align="center">
            <template slot-scope="scope">
              <div v-for="(cart, cIndex) in scope.row.storeOrderCartDtos" :key="cIndex">x {{ cart.cartNum }}</div>
            </template>
          </el-table-column>
          <!-- 平台/类型列暂时隐藏，减少列表字段数量
          <el-table-column prop="appName" :label="$t('storeOrderManage.platform')" align="center"></el-table-column>
          <el-table-column :label="$t('storeOrderManage.type')" align="center">
            <template slot-scope="scope">
              {{ scope.row.cartType == '3307' ? $t('storeOrderManage.service') : $t('storeOrderManage.product') }}
            </template>
          </el-table-column>
          -->
          <el-table-column prop="shopName" :label="$t('storeOrderManage.shop')" align="center"></el-table-column>
          <el-table-column prop="personName" :label="$t('storeOrderManage.userName')" align="center"></el-table-column>
          <el-table-column prop="personCommunityName" :label="$t('storeOrderManage.personCommunity')" align="center"></el-table-column>
          <el-table-column prop="totalPrice" :label="$t('storeOrderManage.orderAmount')" align="right"></el-table-column>
          <el-table-column prop="freightPrice" :label="$t('storeOrderManage.freight')" align="right"></el-table-column>
          <el-table-column :label="$t('storeOrderManage.payAmount')" align="right">
            <template slot-scope="scope">
              <span class="strongAmount">{{ scope.row.payPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('storeOrderManage.couponDiscount')" align="right">
            <template slot-scope="scope">
              {{ scope.row.couponDiscountAmount || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('storeOrderManage.goodsDeduction')" align="right">
            <template slot-scope="scope">
              {{ scope.row.goodsDeductionAmount || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('storeOrderManage.propertyDeduction')" align="right">
            <template slot-scope="scope">
              {{ scope.row.propertyDeductionAmount || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('storeOrderManage.cashPayment')" align="right">
            <template slot-scope="scope">
              <span class="strongAmount">{{ scope.row.cashPayPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('storeOrderManage.orderStatus')" align="center">
            <template slot-scope="scope">
              <span :class="getStateClass(scope.row.state)">{{ scope.row.stateName }}</span>
              <el-tag v-if="scope.row.expired" type="danger" size="mini" class="margin-left-xs">已过期</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('storeOrderManage.createTime')" align="center"></el-table-column>
          <el-table-column :label="$t('storeOrderManage.operations')" align="center" width="120">
            <template slot-scope="scope">
              <el-button size="mini" @click="openOrderDetail(scope.row)">
                {{ $t('storeOrderManage.orderDetail') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handlePageChange" :current-page="conditions.page" :page-size="conditions.row"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryStoreOrder, queryShopsByAdmin, exportData } from '@/api/admin/storeOrderManage/storeOrderManageApi'
import { queryAdminCommunityList } from '@/api/admin/community/communityApi'
import { getDict } from '@/api/shop/shopApi'
import { getStateClass } from '@/utils/orderStateUtil'

export default {
  name: 'StoreOrderManage',
  data() {
    return {
      orders: [],
      total: 0,
      records: 0,
      shops: [],
      communities: [],
      states: [],
      cartTypes: [],
      conditions: {
        orderId: '',
        shopId: '',
        state: '',
        cartType: '',
        prodNameLike: '',
        personName: '',
        personCommunityId: '',
        startTime: '',
        endTime: '',
        page: 1,
        row: 10
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    getStateClass,
    async initData() {
      await this.loadShops()
      await this.loadCommunities()
      await this.loadDictData()
      this.listOrders()
    },
    async loadShops() {
      try {
        const res = await queryShopsByAdmin({ page: 1, row: 1000 })
        this.shops = res.data || []
      } catch (error) {
        console.error('加载商家列表失败:', error)
      }
    },
    async loadCommunities() {
      try {
        const res = await queryAdminCommunityList()
        let list = res.data || []
        // community.queryAdminCommunity 返回的数据可能再包一层 ResultVo
        if (list.data && Array.isArray(list.data)) {
          list = list.data
        }
        this.communities = list
      } catch (error) {
        console.error('加载小区列表失败:', error)
      }
    },
    async loadDictData() {
      try {
        const { data: stateData } = await getDict('store_order', 'state')
        const { data: cartTypeData } = await getDict('store_order_cart', 'cart_type')
        this.states = stateData || []
        this.cartTypes = cartTypeData || []
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async listOrders() {
      try {
        const res = await queryStoreOrder(this.conditions)
        this.total = res.total
        this.records = res.records
        this.orders = res.data || []
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    handlePageChange(val) {
      this.conditions.page = val
      this.listOrders()
    },
    queryOrders() {
      this.conditions.page = 1
      this.listOrders()
    },
    resetOrders() {
      this.conditions = {
        orderId: '',
        shopId: '',
        state: '',
        cartType: '',
        prodNameLike: '',
        personName: '',
        personCommunityId: '',
        startTime: '',
        endTime: '',
        page: 1,
        row: 10
      }
      this.listOrders()
    },
    validateExportDateRange() {
      const { startTime, endTime } = this.conditions
      if (!startTime || !endTime) {
        this.$message.warning('请选择导出时间范围')
        return false
      }
      const start = new Date(startTime).getTime()
      const end = new Date(endTime).getTime()
      if (end - start > 90 * 24 * 3600 * 1000) {
        this.$message.warning('导出时间范围不能超过 3 个月')
        return false
      }
      return true
    },
    openOrderDetail(order) {
      this.$router.push(`/pages/goods/storeOrderCartDetail?orderId=${order.orderId}`)
    },
    async exportOrders() {
      if (!this.validateExportDateRange()) return
      const param = {
        ...this.conditions,
        pagePath: 'storeOrderCart',
        shopId: this.conditions.shopId || '-1'
      }
      try {
        const res = await exportData(param)
        this.$message.success(res.msg)
        if (res.code === 0) {
          this.$router.push('/pages/property/downloadTempFile?tab=下载中心&fileType=storeOrderCart')
        }
      } catch (error) {
        console.error('请求失败处理', error)
      }
    }
  }
}
</script>

<style scoped>
/* 金额区关键列（应付总额/现金支付）加粗，便于平台运营扫读 */
.strongAmount {
  font-weight: 700;
}

.ibox {
  margin-bottom: 20px;
}

.margin-top-sm {
  margin-top: 20px;
}
</style>
